import styled from "styled-components";

import {
  EditorContent,
} from "@tiptap/react";

export const InputTextAreaView = styled.div`
  background-color: ${({ theme }) => theme.palette.surface };
  border: 1px solid ${({ theme }) => theme.colors.border.default };
  border-radius: ${({ theme }) => theme.border_radius.medium }px;
  width: 100%;
  transition: border-color ${({ theme }) => theme.transitions.fast }, box-shadow ${({ theme }) => theme.transitions.fast };

  &:focus-within {
    border-color: ${({ theme }) => theme.palette.primary };
    box-shadow: 0 0 0 3px ${({ theme }) => theme.palette.primary }33;
  }
`;

export const Toolbar = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${({ theme }) => theme.spacing.xx_small }px ${({ theme }) => theme.spacing.xxx_small }px;
  gap: ${({ theme }) => theme.spacing.x_small }px;
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.default };

  & > span {
    min-height: ${({ theme }) => theme.font_size.xxx_small }px;
    font-size: ${({ theme }) => theme.font_size.xxx_small }px;
    line-height: ${({ theme }) => theme.font_size.xxx_small }px;
    color: ${({ theme }) => theme.colors.text.default };
    font-weight: ${({ theme }) => theme.typography.weight.medium };
  }
`;

export const InputText = styled( EditorContent )`
  width: 100%;
  padding: ${({ theme }) => theme.spacing.xx_small }px;
  font-size: ${({ theme }) => theme.font_size.xx_small }px;
  color: ${({ theme }) => theme.colors.text.default };
  cursor: text;

  & > .ProseMirror {
    min-height: 72px;
    outline: none;
  }

  p.is-editor-empty:first-child::before {
    content: attr( data-placeholder );
    float: left;
    height: 0;
    pointer-events: none;

    font-size: ${({ theme }) => theme.font_size.xx_small }px;

    color: ${({ theme }) => theme.colors.text.muted };
  }

  & > .editing {
    border: 1px dashed ${({ theme }) => theme.colors.border.default };
  }
`;
